import { createActionsHook, createStore, type StoreActionApi } from 'react-sweet-state';

import { type ConversationAction } from '@atlassian/rovo-conversation-actions';

export type AISmartButtonState = {
	buttonClickedTimestamp?: number;
	nudges: ConversationAction[];
};

export const initialState: AISmartButtonState = {
	nudges: [],
};

export const actions = {
	setNudges:
		(nudges: ConversationAction[]) =>
		({ setState }: StoreActionApi<AISmartButtonState>) => {
			setState({ nudges });
		},
	setButtonClickedTimestamp:
		(buttonClickedTimestamp: number) =>
		({ setState }: StoreActionApi<AISmartButtonState>) => {
			setState({ buttonClickedTimestamp });
		},
};

export const AISmartButtonStore = createStore({
	initialState,
	actions,
	name: 'AISmartButtonStore',
});

export const useAISmartButtonActions = createActionsHook(AISmartButtonStore);
export type AISmartButtonActions = ReturnType<typeof useAISmartButtonActions>;
